'use strict';

const Constants = require('../constants/AppConstants'),
    DashboardServiceCache = require('../services/DashboardServiceCache'),
    SessionStore = require('./../stores/SessionStore'),
    DashboardActionCreators = require('actions/DashboardActionCreators'),
    DashboardSpinnerEl = require('views/Dashboard/DashboardSpinnerHolder');

/**
 * The draft mechanism to handler an effective/optimistic way the orders that we add, change or delete from the Dashboard.
 * @type {{operations: Array, addOrder: Function, changeOrder: Function, deleteOrder: Function, _getTemporaryId: Function, _toDraft: Function}}
 */
const DraftSchedule = {

    /**
     * The current applicant.
     */
    applicant: SessionStore.getCurrentApplicant() ,

    /**
     * Save a draft order with temporary id that will be replace once we publish all the
     * operation of the current draft.
     * @param order
     * @returns {*}
     */
    addOrder: function (order) {
        DashboardActionCreators.addOrderDraft(order);
        DashboardSpinnerEl.show();
        DashboardServiceCache.addOperation({
            typeOperation: Constants.ORDER_OPERATION_NEW,
            order: order,
            isSaved: false
        });
    },

    /**
     * Add an change order operation to the stack of operations.
     * @param order
     */
    changeOrder: function (order) {
        DashboardSpinnerEl.show();
        DashboardServiceCache.addOperation({
            typeOperation: Constants.ORDER_OPERATION_CHANGE,
            order: order,
            isSaved: false
        });
    },

    /**
     * Add an delete order operation to the stack of operations.
     * @param order
     */
    removeOrder: function (order) {
        DashboardSpinnerEl.show();
        DashboardServiceCache.addOperation({
            typeOperation: Constants.ORDER_OPERATION_DELETE,
            order: order,
            isSaved: false
        });
    }
};

module.exports = DraftSchedule;



/** WEBPACK FOOTER **
 ** ./src/pollers/DraftSchedule.js
 **/